import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const GraphBasicsTerminologyModule = () => (
  <DMModuleSubtopic
    title="Basics and Terminology of Graphs"
    videos={[
      "https://www.youtube.com/embed/U_V715lstgY",
      "https://www.youtube.com/embed/c3r8SqJoEp8",
      "https://www.youtube.com/embed/-VsTYT8QsmY",
      "https://www.youtube.com/embed/y6EgXkswWZQ"
    ]}
    takeaways={[]}
    questions={[
        {image:"/dm_30.png"},
        {image:"/dm_31.png"},
        {image:"/dm_32.png"},

    ]}
    exampleVideos={[]}
  />
);

export default GraphBasicsTerminologyModule;
